import React, { useEffect, useRef, useState } from "react";
import { NotificationMenuContainer, PromoCodeRow } from "./style";
import InfiniteScroll from "react-infinite-scroll-component";
import { formatDateInNumbers } from "../../../../../lib/normalizeDate";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { connect } from "react-redux";
import ErrorHandle from "../../../../../components/error/mainError";
import { withRouter } from "react-router-dom";
import { BoxLoading } from "../../../../../components/loading/components/boxLoading/index";
import { PROJECT_USER_ID } from "../../../../../constants/storageKeys";
import { isPremium } from "../../../../../assets/checkPremium";
import { isOwnerInProject } from "../../../../../assets/checkAccess";
import { convertRialToToman } from "../../../../../lib/convertRialToToman";
import { getNormalizedProjectUserTeams } from "../../../../../assets/normalizedProjectUserTeams";
import {
  goToProject,
  showDialogOnSelectedNotOwnNotPremiumProject
} from "../../../../../assets/selectProjectUserOrPanel";
import {
  DEACTIVATED_ACCESS_IN_PROJECT_USER_FOR_NOTIFICATION_CLICK,
  REMOVED_PROJECT_FOR_NOTIFICATION_CLICK,
  SWITCH_TO_CUSTODIAN_PANEL_DEFAULT_TEAM_PROJECT_USER,
  SWITCH_TO_CUSTODIAN_PANEL_NOT_DEFAULT_TEAM_PROJECT_USER,
  SWITCH_TO_MANAGER_PANEL_PROJECT_USER,
  WARNING_SINGLE_BUTTON_TEXT
} from "../../../../../constants/otherTexts";
import {
  PROJECT_USER_ROLES,
  PROJECT_USER_STATE
} from "../../../../../constants/projectUser";
import {
  SUMMARY_PETTY_CASH_MANAGER,
  SUMMARY_PETTY_CASH_PETTY_CASHIER
} from "../../../../../constants/urls";
import {
  NotificationAction,
  ProjectAction
} from "../../../../../actions/index";
import {
  ACTION_TYPE,
  ANNOUNCEMENT_LINK_TYPES,
  NOTICE_TYPES,
  NOTIFICATION_TYPES
} from "../../../../../constants/notificationTypes";
import { EmptyState } from "../../../../../components/emptyState/index";
import { Menu } from "../../../../../projectSpecificComponents/menu/index";
import NotificationCard from "./components/notificationCard";
import { toastr } from "react-redux-toastr";
import { Confirm } from "../../../../../components/confirm";
import InvitationToProject from "../../../../../projectSpecificComponents/invitationToProject";
import ThreadCard from "../../../../../projectSpecificComponents/ticketThreadCard";
import AnnouncementModal from "./components/announcementModal";

const CONFIRM_INITIALIZED_STATE = {
  show: false,
  message: "",
  actions: {
    accept: {
      text: "",
      func: () => {}
    },
    reject: { text: "" }
  }
};

const ANNOUNCEMENT_MODAL_INITIAL_STATE = {
  show: false,
  id: ""
};

const Notifications = props => {
  const {
    getList,
    list,
    history,
    read,
    remove,
    error,
    loading,
    isSeenArray,
    readProcessing,
    removeProcessing,
    removedId,
    getProjects,
    projectsAreFetched,
    activeProjects,
    show,
    handleShow
  } = props;

  const isFirstRender = useRef(true);

  const [notifications, setNotifications] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMorePage, setHasMorePage] = useState(true);
  const [announcementModalData, setAnnouncementModalData] = useState(
    ANNOUNCEMENT_MODAL_INITIAL_STATE
  );

  const [confirm, setConfirm] = useState(CONFIRM_INITIALIZED_STATE);

  const request = page => {
    getList(page);
  };

  useEffect(() => {
    request();
    if (!projectsAreFetched) {
      getProjects();
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      if (list.notifications.data.length > 0) {
        setNotifications([...notifications, ...list.notifications.data]);
      }
    }
  }, [list.notifications]);

  useEffect(() => {
    if (removedId !== null) {
      const newNotifications = notifications.filter(
        notification => notification.id !== removedId
      );
      setNotifications(newNotifications);
      if (newNotifications.length === 0) {
        setPageNumber(1);
        request();
      }
    }
  }, [removedId]);

  const handleClickOnAnnouncement = data => {
    const linkType = data.link_type;
    switch (linkType) {
      case ANNOUNCEMENT_LINK_TYPES.EXTERNAL:
        window.open(data.external_link, "_blank");
        break;
      case ANNOUNCEMENT_LINK_TYPES.INTERNAL:
        setAnnouncementModalData({ show: true, id: data.id });
        break;
    }
  };

  const handleOnNotificationClick = data => {
    const type = parseInt(data.type);
    let destinationLink,
      doNothing = false;
    const id = data.model_id;
    switch (type) {
      case NOTIFICATION_TYPES.SEND_PETTY_CASH:
      case NOTIFICATION_TYPES.REQUEST_RETURN_PETTY_CASH:
      case NOTIFICATION_TYPES.APPROVE_PETTY_CASH:
      case NOTIFICATION_TYPES.REJECT_PETTY_CASH:
        destinationLink = `${SUMMARY_PETTY_CASH_MANAGER}/${id}`;
        break;
      case NOTIFICATION_TYPES.RETURN_PETTY_CASH:
        destinationLink = `${SUMMARY_PETTY_CASH_PETTY_CASHIER}/${id}`;
        break;
      default:
        doNothing = true;
    }
    if (!doNothing) {
      const projectUserId = parseInt(data.project_user_id);
      if (projectUserId === parseInt(localStorage.getItem(PROJECT_USER_ID))) {
        history.push(destinationLink);
      } else {
        handleGoToClickedNotificationProjectUser(
          projectUserId,
          destinationLink
        );
      }
    }
  };

  const handleGoToClickedNotificationProjectUser = (
    projectUserId,
    destinationLink
  ) => {
    let projectObj, projectUserObj;
    activeProjects.forEach(project =>
      project.project_users.forEach(projectUser => {
        if (parseInt(projectUser.id) === projectUserId) {
          projectObj = project;
          projectUserObj = projectUser;
        }
      })
    );
    if (projectUserObj && projectObj) {
      const isForManagerPanel =
        projectUserObj.user_type !== PROJECT_USER_ROLES.CUSTODIAN;
      const isActive = projectUserObj.state === PROJECT_USER_STATE.ACTIVE;
      const _isPremium = isPremium(projectObj.premium_state);
      const rolesInDestinationProject = projectObj.project_users
        .filter(projectUser => projectUser.user_id === projectUserObj.user_id)
        .map(projectUser => projectUser.user_type);
      const isOwner = isOwnerInProject(rolesInDestinationProject);
      let confirmMessage = "";
      if (isActive) {
        if (isOwner || _isPremium) {
          if (!isForManagerPanel) {
            const normalizedProjectUser = getNormalizedProjectUserTeams(
              projectObj.teams,
              [projectUserObj]
            )[0];
            if (normalizedProjectUser.project_user_teams.length === 1) {
              const team = normalizedProjectUser.project_user_teams[0];
              if (team.is_default) {
                confirmMessage = SWITCH_TO_CUSTODIAN_PANEL_DEFAULT_TEAM_PROJECT_USER(
                  projectObj.name
                );
              } else {
                const teamName = team.name;
                confirmMessage = SWITCH_TO_CUSTODIAN_PANEL_NOT_DEFAULT_TEAM_PROJECT_USER(
                  projectObj.name,
                  teamName
                );
              }
            }
          } else {
            confirmMessage = SWITCH_TO_MANAGER_PANEL_PROJECT_USER(
              projectObj.name
            );
          }
          showWarning({
            message: confirmMessage,
            actions: {
              accept: {
                text: "بله",
                func: () =>
                  goToProject(projectUserObj, projectObj, true, destinationLink)
              },
              reject: { text: "انصراف" }
            }
          });
        } else {
          showDialogOnSelectedNotOwnNotPremiumProject(
            rolesInDestinationProject,
            projectObj
          );
        }
      } else {
        confirmMessage = DEACTIVATED_ACCESS_IN_PROJECT_USER_FOR_NOTIFICATION_CLICK;
        showWarning({
          message: confirmMessage,
          actions: {
            accept: {
              text: "",
              func: () => {}
            },
            reject: { text: WARNING_SINGLE_BUTTON_TEXT }
          }
        });
      }
    } else {
      showWarning({
        message: REMOVED_PROJECT_FOR_NOTIFICATION_CLICK,
        actions: {
          accept: {
            text: "",
            func: () => {}
          },
          reject: { text: WARNING_SINGLE_BUTTON_TEXT }
        }
      });
    }
  };
  const handleOnClick = (notificationType, data) => {
    switch (notificationType) {
      case NOTICE_TYPES.ANNOUNCEMENT:
        handleClickOnAnnouncement(data);
        break;
      case NOTICE_TYPES.NOTIFICATION:
        handleOnNotificationClick(data);
        break;
    }
    handleReadUnRead(notificationType, data, ACTION_TYPE.READ);
  };
  const handleReadUnRead = (noticeType, item, passedAction) => {
    const isSeen =
      isSeenArray[item.id] !== undefined ? isSeenArray[item.id] : item.is_read;
    const action =
      isSeen === false
        ? ACTION_TYPE.READ
        : isSeen === true
        ? ACTION_TYPE.UNREAD
        : "";
    if (
      action &&
      ((passedAction && passedAction === action) || !passedAction)
    ) {
      read(noticeType, item.id, action);
    }
  };

  const paginationClickHandler = () => {
    const meta = list.notifications.meta;
    let currentPage = error ? pageNumber : meta.current_page;
    let nextPage = error ? currentPage : currentPage + 1;
    if (meta && meta.last_page !== undefined) {
      if (error || meta.last_page > currentPage) {
        request(nextPage);
        setPageNumber(nextPage);
        setHasMorePage(true);
      } else {
        setHasMorePage(false);
      }
    }
  };

  const showEmptyState = () => {
    return (
      list.pending_projects.length +
        list.tickets.length +
        list.announcements.length +
        list.promo_codes.length +
        notifications.length ===
      0
    );
  };
  const showWarning = config => {
    setConfirm({
      show: true,
      ...config
    });
  };
  const closeWarning = () => {
    setConfirm(CONFIRM_INITIALIZED_STATE);
  };

  return (
    <Menu showMenu={show} close={() => handleShow(false)} isLarge={true}>
      {announcementModalData.show && (
        <AnnouncementModal
          showModal={announcementModalData.show}
          announcementId={announcementModalData.id}
          closeHandler={() =>
            setAnnouncementModalData(ANNOUNCEMENT_MODAL_INITIAL_STATE)
          }
        />
      )}
      <Confirm
        show={confirm.show}
        content={{
          type: "warning",
          icon: "icon mapsa-notification",
          message: confirm.message,
          acceptButtonText: confirm.actions.accept.text,
          rejectButtonText: confirm.actions.reject.text
        }}
        acceptHandler={() => confirm.actions.accept.func()}
        rejectHandler={() => closeWarning()}
        close={() => closeWarning()}
      />
      <NotificationMenuContainer id="scrollableDiv">
        <div className="notification-title">اعلان‌ها</div>
        {loading && pageNumber === 1 && (
          <div className="loading-container">{BoxLoading()}</div>
        )}
        <div className="notification-inner-wrapper">
          {!error &&
            list.pending_projects.length > 0 &&
            list.pending_projects.map(project => (
              <InvitationToProject key={project.id} project={project} />
            ))}
          {!error &&
            list.tickets.length > 0 &&
            list.tickets.map(ticket => (
              <ThreadCard key={ticket.id} {...ticket} />
            ))}
          {!error &&
            list.announcements.length > 0 &&
            list.announcements.map(announcement => {
              const isSeen =
                isSeenArray[announcement.id] !== undefined
                  ? isSeenArray[announcement.id]
                  : announcement.is_read;
              return (
                <NotificationCard
                  key={announcement.id}
                  data={announcement}
                  isAnnouncement={true}
                  isSeen={isSeen}
                  readLoading={readProcessing[announcement.id]}
                  onClick={() =>
                    handleOnClick(NOTICE_TYPES.ANNOUNCEMENT, announcement)
                  }
                  handleReadUnReadClick={() => {
                    handleReadUnRead(NOTICE_TYPES.ANNOUNCEMENT, announcement);
                  }}
                />
              );
            })}
          {!error &&
            list.promo_codes.length > 0 &&
            list.promo_codes.map(promoCode => (
              <PromoCodeComponent key={promoCode.id} promoCode={promoCode} />
            ))}
          {!error && notifications.length > 0 && (
            <InfiniteScroll
              dataLength={notifications.length}
              next={() => paginationClickHandler()}
              hasMore={hasMorePage}
              loader={
                pageNumber > 1 &&
                !error && (
                  <div className="page-loading-container">
                    <BoxLoading size="small" />
                  </div>
                )
              }
              scrollableTarget="scrollableDiv"
            >
              {notifications.map(notification => {
                const isSeen =
                  isSeenArray[notification.id] !== undefined
                    ? isSeenArray[notification.id]
                    : notification.is_read;
                return (
                  <NotificationCard
                    key={notification.id}
                    data={notification}
                    isSeen={isSeen}
                    readLoading={readProcessing[notification.id]}
                    onClick={() =>
                      handleOnClick(NOTICE_TYPES.NOTIFICATION, notification)
                    }
                    handleReadUnReadClick={() => {
                      handleReadUnRead(NOTICE_TYPES.NOTIFICATION, notification);
                    }}
                    handleRemove={() => {
                      remove(notification.id);
                    }}
                    removeLoading={removeProcessing[notification.id]}
                  />
                );
              })}
            </InfiniteScroll>
          )}
        </div>
        {!loading && !error && showEmptyState() && (
          <EmptyState tabIcon={"icon mapsa-notification"}>
            در واحد خبر رسانی، خبری برای خواندن وجود ندارد. بعدا به اینجا سر
            بزنید.
          </EmptyState>
        )}
        <ErrorHandle message={error} request={paginationClickHandler} />
      </NotificationMenuContainer>
    </Menu>
  );
};

const mapStateToProps = store => {
  return {
    list: store.Notification.list,
    loading: store.Notification.loading,
    readProcessing: store.Notification.readProcessing,
    isSeenArray: store.Notification.isSeen,
    removeProcessing: store.Notification.removeProcessing,
    removedId: store.Notification.removedId,
    error: store.Notification.error,

    activeProjects: store.Project.active_projects,
    projectsAreFetched: store.Project.is_fetched
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getList: page => {
      dispatch(NotificationAction.getList(page));
    },
    read: (type, id, readOrUnread) => {
      dispatch(NotificationAction.read(id, type, readOrUnread));
    },
    remove: id => {
      dispatch(NotificationAction.remove(id));
    },

    getProjects: () => dispatch(ProjectAction.get())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Notifications));

const PromoCodeComponent = ({ promoCode }) => {
  return (
    <PromoCodeRow>
      <div className="inner-container">
        <div className="promoText">
          <div className="main-text">
            {`${promoCode.text} - ${promoCode.discount_percent} درصد تخفیف`}
            {promoCode.max_discount &&
              ` تا سقف ${convertRialToToman(promoCode.max_discount)} تومان`}
          </div>
          {promoCode.expire_at && (
            <div className="description">
              {`اعتبار تا : ${formatDateInNumbers(promoCode.expire_at)}`}
            </div>
          )}
        </div>
        <CopyToClipboard
          text={promoCode.code}
          onCopy={() =>
            toastr.success(" ", `کد تخفیف ${promoCode.code} کپی شد.`)
          }
        >
          <div className="promoCodeLabel">
            <i className="icon mapsa-copy" />
            {promoCode.code}
          </div>
        </CopyToClipboard>
      </div>
    </PromoCodeRow>
  );
};
